var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsPermMediaOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    stroke: 1,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.3337H25.3333L20.7333 11.3337L17.6666 15.3337L15.5999 12.667L11.9999 17.3337ZM3.99992 28.0003C3.26659 28.0003 2.63903 27.7394 2.11725 27.2177C1.59547 26.6959 1.33414 26.0679 1.33325 25.3337V8.00033H3.99992V25.3337H26.6666V28.0003H3.99992ZM9.33325 22.667C8.59992 22.667 7.97236 22.4061 7.45059 21.8843C6.92881 21.3625 6.66747 20.7345 6.66659 20.0003V5.33366C6.66659 4.60033 6.92792 3.97277 7.45059 3.45099C7.97325 2.92921 8.60081 2.66788 9.33325 2.66699H15.9999L18.6666 5.33366H27.9999C28.7333 5.33366 29.3613 5.59499 29.8839 6.11766C30.4066 6.64033 30.6675 7.26788 30.6666 8.00033V20.0003C30.6666 20.7337 30.4057 21.3617 29.8839 21.8843C29.3621 22.407 28.7341 22.6679 27.9999 22.667H9.33325ZM9.33325 20.0003H27.9999V8.00033H17.5666L14.8999 5.33366H9.33325V20.0003Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsPermMediaOutline);
export default __webpack_public_path__ + "static/media/material-symbols_perm-media-outline.8901cb5986f7b34360e51934e695a0e9.svg";
export { ForwardRef as ReactComponent };